import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { Button } from 'react-bootstrap';

import { translate } from 'react-i18next';
import { ReduxAsyncConnect, asyncConnect, reducer as reduxAsyncConnect } from 'redux-connect';


import { loadFiche } from 'redux/modules/fiches';

import { FicheForm, ModeOpe } from 'components';

import { isLoaded as areGroupsLoaded, load as loadGroups } from 'redux/modules/groups';

import * as productActions from 'redux/modules/products';


require('./geosuggest.css');
import ReactModal from 'react-modal';

var modalStyles =
{
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.75)',
    zIndex: 1000000
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '400px'

  }
}

@asyncConnect([{
  promise: ({ store: { dispatch, getState }, params }) => {
    const promises = [];
    promises.push(dispatch(loadFiche(params.ficheID, params)));
    promises.push(dispatch(loadGroups(params)));
    promises.push(dispatch(productActions.load(0, params)));
    return Promise.all(promises);
  }
}])
@connect(
  state => ({
    groups: state.groups.data,
    fiche: state.fiches.fiche,
    allProducts: state.products.data
  })
)
@translate(['common'])

export default class EditFiche extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handleOpenModal() {
    this.setState({ showModal: true });
  }

  handleCloseModal() {
    var self = this;

    this.setState({ showModal: false }, () => {
      self.reloadForm();
    });

  }

  render() {
    const {
      t, groups, fiche, allProducts
    } = this.props;

    var groups_ids = groups.map((g) => {
      return g.id;
    })


    return (
      <div className={' container'}>
        <Helmet title={t('main.edit_site')} />
        <h1>
          {t('main.edit_site')}        
          <Button bsStyle="primary" onClick={this.handleOpenModal}>
            {t('main.help')}
          </Button>
        </h1>

        <FicheForm action="update" urlParams={this.props.params}
          formKey={String(fiche.id)} ficheId={String(fiche.id)}
          key={String(fiche.id)} allProducts={allProducts}
          initialValues={{ sites: fiche, groups: groups_ids, products: fiche.products }}
          pristineValues={{ sites: fiche, groups, products: fiche.products }}
        />
        <ReactModal
          isOpen={this.state.showModal}
          contentLabel="" style={modalStyles}
        >

          <div>
            <div style={{position:'sticky', top: 0, textAlign:'right', background:'white', padding:'5px 0', zIndex: 1}}>
              <i onClick={this.handleCloseModal} className="fa fa-times-circle fa-2x" style={{color: '#888', cursor:'pointer'}}/>
            </div>
            <p><ModeOpe /></p>
          </div>
        </ReactModal>
      </div>
    );
  }
}
